<div class="token-color-picker-container">
  @if (showDropdown) {
    <div class="dropdown-with-preview">
      <div class="color-preview-container">
        <div class="color-preview-backdrop">
          <div
            class="color-preview-circle"
            [style.background-color]="getPreviewColor(dropdownControl.value, colorPickerControl.value)"
            [style.height]="circleDiameter"
            [style.width]="circleDiameter"
            [cpPosition]="cpPosition"
            [(colorPicker)]="colorPickerValue"
            (colorPickerChange)="onColorPickerValueChange($event)"
            (colorPickerClose)="onColorPickerClose($event)"
            (cpToggleChange)="onColorPickerToggle($event)"
            [cpPresetColors]="[]"
          ></div>

          @if (showEyeDropper) {
            <button
              [matTooltip]="'PRESENTER.COLOR_PICKER.PICK_FROM_SCREEN' | translate"
              matRipple
              class="eye-dropper-button"
              type="button"
              (click)="pickColorFromScreen()"
              [disabled]="!eyeDropperSupported"
              [attr.aria-label]="'PRESENTER.COLOR_PICKER.PICK_FROM_SCREEN' | translate"
            >
              <gb-icon [icon]="'eyedrop'" [library]="IconLibrary.ionic" height="15px"></gb-icon>
            </button>
          }
        </div>
      </div>

      <mat-form-field>
        <mat-label [translate]="labelTranslateKey"></mat-label>
        <mat-select [formControl]="dropdownControl">
          @for (token of colorTokens; track token) {
            <mat-option [value]="token">
              <div class="option-preview-container">
                <div class="color-preview-dot" [style.background-color]="getPreviewColor(token, null)"></div>
                <span>{{ 'PRESENTER.COLOR_TOKENS.' + token.toUpperCase() | translate }}</span>
              </div>
            </mat-option>
          }
          <mat-option value="custom_color">
            <div class="option-preview-container">
              <div
                class="color-preview-dot"
                [style.background-color]="getPreviewColor('custom_color', colorPickerControl.value)"
              ></div>
              @if (colorPickerControl.value) {
                <span>{{ colorPickerControl.value | uppercase }}</span>
              } @else {
                <span translate="PRESENTER.COLOR_TOKENS.CUSTOM_COLOR"></span>
              }
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  } @else {
    <gb-color-picker
      [control]="colorPickerControl"
      [labelTranslateKey]="labelTranslateKey"
      [cpPosition]="cpPosition"
      [circleDiameter]="circleDiameter"
      (colorPickerClose)="onColorPickerClose($event)"
      [showEyeDropper]="showEyeDropper"
    ></gb-color-picker>
  }
</div>
